module.exports = __webpack_public_path__ + "static/media/joinedTournaments_500_1000.2f3dc790.png";